<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17.983" viewBox="0 0 16 17.983" class="log-off-icon">
    <path class="a" d="M13,4.009a1,1,0,1,0-2,0l0,8a1,1,0,1,0,2,0Z" transform="translate(-4 -3.009)"/>
    <path class="a"
          d="M4,12.992A7.975,7.975,0,0,1,6.343,7.335L7.757,8.749a6,6,0,1,0,8.485,0l1.414-1.414A8,8,0,1,1,4,12.992Z"
          transform="translate(-4 -3.009)"/>
  </svg>
</template>

<script>
export default {
  name: "LogOffIcon"
}
</script>

<style scoped>
.a {
  fill: #3e4041;
}
</style>
